import { render, staticRenderFns } from "./CreatedClasses.vue?vue&type=template&id=65546710&scoped=true"
import script from "./CreatedClasses.vue?vue&type=script&lang=js"
export * from "./CreatedClasses.vue?vue&type=script&lang=js"
import style0 from "./CreatedClasses.vue?vue&type=style&index=0&id=65546710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65546710",
  null
  
)

export default component.exports